"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualCargoCommodity = void 0;
class AnnualCargoCommodity {
    constructor(primary, secondary) {
        this.primary = primary;
        this.secondary = secondary;
    }
    getSecondaryCommodities(primaryId, allSecondary) {
        return this.secondary.filter(secondary => secondary.belongsTo.includes(primaryId) || allSecondary);
    }
    getSecondaryCommoditiesByName(primaryName) {
        const primary = this.primary.find(primaryCom => primaryCom.name === primaryName);
        if (primary)
            return this.getSecondaryCommodities(primary.id, primary.allSecondary);
        return [];
    }
}
exports.AnnualCargoCommodity = AnnualCargoCommodity;
AnnualCargoCommodity.fromObj = (data) => new AnnualCargoCommodity(data.primary, data.secondary);
//# sourceMappingURL=annualCargoCommodity.class.js.map